import { jsx, jsxs } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { createContext, memo } from "react";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { FieldContainer } from "../Forms/FieldContainer/FieldContainer.js";
import { Box } from "../Box/Box.js";
const UseTableElementContext = createContext(true);
const Table = memo(({
  /*useTableElement = true, */
  bare,
  className: classNameProp,
  ...props
}) => {
  const componentClassName = useClassNameFactory("table");
  const className = componentClassName(null, [
    toEnumViewClass(props.size),
    toEnumViewClass(props.justification, "justifyStart"),
    classNameProp
  ]);
  const table = /* @__PURE__ */ jsx("div", { className: componentClassName("wrapper"), children: /* @__PURE__ */ jsxs("table", { className, children: [
    props.tableHead && /* @__PURE__ */ jsx("thead", { children: props.tableHead }),
    /* @__PURE__ */ jsx("tbody", { children: props.children })
  ] }) });
  return /* @__PURE__ */ jsx(UseTableElementContext.Provider, { value: (
    /*useTableElement*/
    true
  ), children: /* @__PURE__ */ jsx(FieldContainer, { className: componentClassName("container"), label: !bare && props.heading, useLabelElement: false, children: /* @__PURE__ */ jsx(Box, { padding: false, className: componentClassName("container-box"), children: table }) }) });
});
Table.displayName = "Table";
export {
  Table,
  UseTableElementContext
};
//# sourceMappingURL=Table.js.map
